"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const datahubPlayerTypes_1 = require("./datahubPlayerTypes");
class PlayerTrackingService {
    constructor() {
        this.changePlayerEnableEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ProductSettings,
                name: datahubPlayerTypes_1.Names.ActivePlayer
            });
        };
        this.changePlayerDisableEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ProductSettings,
                name: datahubPlayerTypes_1.Names.DeactivatePlayer
            });
        };
        this.openDeactivatePlayerModalEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ProductSettings,
                name: datahubPlayerTypes_1.Names.DeactivatePlayerConfirmation
            });
        };
        this.cancelPlayerDeactivationOnProductSettingsEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ProductSettings,
                name: datahubPlayerTypes_1.Names.DismissPlayerModalConfirmation
            });
        };
        this.streamingEnabledOnContentPageLoadEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ProductSettings,
                name: datahubPlayerTypes_1.Names.PlayerEnabledOnLoad
            });
        };
        this.streamingDisabledOnContentPageLoadEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ProductSettings,
                name: datahubPlayerTypes_1.Names.PlayerDisabledOnLoad
            });
        };
        this.cancelPlayerDeactivationOnContentPageEvent = (params) => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ContentPage,
                name: datahubPlayerTypes_1.Names.DismissPlayerModalConfirmation,
                params
            });
        };
        this.confirmPlayerActivationOnContentPageEvent = (params) => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ContentPage,
                name: datahubPlayerTypes_1.Names.ActivePlayerConfirmed,
                params
            });
        };
        this.openActivatePlayerModalEvent = (params) => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ContentPage,
                name: datahubPlayerTypes_1.Names.ActivePlayer,
                params
            });
        };
        this.agreeTermsToActivatePlayerEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ContentPage,
                name: datahubPlayerTypes_1.Names.AgreeTermsToActivePlayer
            });
        };
        this.disagreeTermsToActivatePlayerEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ContentPage,
                name: datahubPlayerTypes_1.Names.DisagreeTermsToActivePlayer
            });
        };
        this.showPlayerActivateBannerEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ContentPage,
                name: datahubPlayerTypes_1.Names.ShowPlayerActivateBanner
            });
        };
        this.showPlayerAlreadyActivatedEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ContentPage,
                name: datahubPlayerTypes_1.Names.PlayerAlreadyActivated
            });
        };
        this.errorOnActivatePlayerInProductSettingsEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ProductSettings,
                name: datahubPlayerTypes_1.Names.ErrorToActivePlayer
            });
        };
        this.errorOnDeactivatePlayerInProductSettingsEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ProductSettings,
                name: datahubPlayerTypes_1.Names.ErrorToDeactivatePlayer
            });
        };
        this.errorOnActivatePlayerInContentPageEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: datahubPlayerTypes_1.Groups.ContentPage,
                name: datahubPlayerTypes_1.Names.ErrorToActivePlayer
            });
        };
    }
}
exports.default = new PlayerTrackingService();
